import {
  type BranchKey,
  STANDARD_BRANCH,
  useFetchConciseBranch,
} from '@festina-life/api'
import { notEmpty } from '@festina-life/core'
import { CircularSpinner } from '@festina-life/ui/feedback'
import { useMemo } from 'react'

import { useOperationsContext } from '../../../workspace/operationsContext'
import { UnapprovedOperations } from '../../statusIndicators/UnapprovedOperations'

type Props = {
  branchKey: BranchKey
}

export const BranchLoadingStatusAndOperationCount = ({ branchKey }: Props) => {
  const { isLoadingErrors, isLoading: isLoadingOperations } =
    useOperationsContext()
  const {
    data: currentBranchConciseChangesets,
    isFetching: isLoadingChangesets,
  } = useFetchConciseBranch({
    branchName: branchKey.name,
    server: branchKey.server,
    enabled: branchKey.name !== STANDARD_BRANCH,
    shouldIncludeBaseConciseChangesets: false,
  })

  const unapprovedOperationsCount = useMemo(
    () =>
      (currentBranchConciseChangesets ?? []).flatMap((changeset) =>
        (changeset?.operations ?? [])
          .filter(notEmpty)
          .filter((operation) => !operation.approvalTime),
      ).length,
    [currentBranchConciseChangesets],
  )

  const isLoading =
    isLoadingErrors || isLoadingOperations || isLoadingChangesets

  return (
    <>
      {isLoading && <CircularSpinner className="size-4" />}
      {!!unapprovedOperationsCount && (
        <UnapprovedOperations count={unapprovedOperationsCount} />
      )}
    </>
  )
}
